// extracted by mini-css-extract-plugin
module.exports = {"h1":"vd__2N3_I","h2":"vd__1QGnC","h3":"vd__1Tkxo","h4":"vd__gSj4S","subtitle":"vd__2ja85"};